import { useCallback, useEffect } from 'react';

export function useDocumentKeydown(
  key: string,
  cb: (e: KeyboardEvent) => unknown,
) {
  const onKeydown = useCallback(
    function (e: KeyboardEvent) {
      if (e.key === key) {
        cb(e);
      }
    },
    [cb, key],
  );

  useEffect(
    function () {
      document.addEventListener('keydown', onKeydown);
      return () => document.removeEventListener('keydown', onKeydown);
    },
    [onKeydown],
  );
}
